import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';

import Utils from 'utils/Utils.js'
import LoadInline from '../loading/LoadInline.js';
import {colors, fontSizes, fonts, layout} from 'style';
import defaultAvatar from 'img/default-avatar.png';

const style = {
    content: {
        padding: '1px',
        position:'relative',
        ...fonts.body,
        lineHeight: '1.5',
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        marginLeft: 'auto',
        marginRight: 'auto',
        backgroundColor: 'white',
    },
    cards: {
        justifyContent: 'center'
    },
    avatarContainer: {
        display: 'block',
        fontSize: '1.5em',
        width: '280px',
        verticalAlign: 'middle',
        textAlign: 'center',
        lineHeight: '95px',
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        left: '-8px',
    },
    avatarWrapper: {
        display: 'inline-block',
        borderRadius: '50%',
        height: '70px',
        width: '55px',
        verticalAlign: 'middle',
    },
    avatar: {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '70px',
        width: '70px',
        verticalAlign: 'top',
    },
    button: {
        margin: '0',
        width: '50%',
        border: 'none',
        borderRadius: '0',
        backgroundColor: 'transparent',
    },
    decline: {
        color: colors.themeMaroon,
        borderRight: '1px solid rgba(0,0,0,0.5)',
    },
    accept: {
        color: colors.themeBlue,
    },
    title: {
        color: colors.themeBlue,
        fontWeight: 'bold',
        ...fonts.body,
        lineHeight: '1.5',
    },
    message: {
        textAlign: 'center',
        opacity: '0.6',
        ...fonts.body,
        lineHeight: '1.5',
    },
    empty: {
        textAlign: 'center',
    },
    emptyMessage: {
        color: colors.themeBlue,
        ...fonts.body,
        lineHeight: '1.5',
    },
    mailIcon: {
        opacity: '0.5',
    }

};


const ChallengeInvitations = ({t, busy, members, onStartChallenge, onDeclineInvitation, getAvatars}) => (
    <div className="full-height" style={style.content}>
        {busy && 
            <LoadInline centered vcentered /> 
        }
        {!busy &&
            <div>
                {members.length>0 &&
                    <Card.Group style={style.cards}>
                    {members.map(member=>(
                        <Card key={member.challengeRecord.id}>
                            <Card.Content>
                                {Boolean(member.challengeRecord && member.challengeRecord.challenge) &&
                                    <div style={style.title}>{member.challengeRecord.challenge.title}</div>
                                }
                                <div style={style.avatarContainer}>
                                    {getAvatars(member.challengeRecord).map((url,avatarIndex)=>(
                                        <div key={avatarIndex} style={style.avatarWrapper}><img style={{...style.avatar}} src={url ? url : defaultAvatar}></img></div>
                                    ))}
                                </div>
                                {Boolean(member.challengeRecord && member.challengeRecord.userProfile) &&
                                    <div style={style.message}>
                                        {t('{{name}} has invited you to join their team', {name:member.challengeRecord.userProfile.firstName})}
                                    </div>
                                }
                                <Button style={{...style.button, ...style.decline}} onClick={()=>onDeclineInvitation(member.challengeRecord.id)}>{t('Decline')}</Button>
                                <Button style={{...style.button, ...style.accept}} onClick={()=>onStartChallenge(member.challengeRecord)}>{t('Accept')}</Button>
                            </Card.Content>
                        </Card>
                    ))}
                    </Card.Group>
                }
                {members.length==0 &&
                    <div style={style.empty}>
                        <Icon style={style.mailIcon} size='massive' className='icon-archive' />
                        <div style={style.emptyMessage}>{t('No New Invites')}</div>
                    </div>
                }
            </div>
        }
    </div>
);

export default translate('teamchallenges')(ChallengeInvitations);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/ChallengeInvitations.js